/*********************************************************************************************
* Initialize the sticky CTA behavior.
* Desktop: Show sticky CTA only after scrolling PAST the main CTA (user must see it first)
* Mobile: Show sticky CTA whenever main CTA is not visible (current behavior)
*/
function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta]');

	// Vérifie que les éléments existent (silencieux si absent, normal sur pages non-produit)
	if (!classicCTA || !stickyCTA) {
		return;
	}

	// Track si l'utilisateur a déjà vu le CTA principal (desktop seulement)
	let hasSeenMainCTA = false;

	// Fonction pour vérifier si on est sur mobile
	const isMobile = () => window.innerWidth < 769;

	// Crée un observateur pour surveiller la visibilité du CTA principal
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const isDesktop = !isMobile();

			if (entry.isIntersecting) {
				// Le CTA principal est visible
				hasSeenMainCTA = true; // L'utilisateur a vu le CTA
				stickyCTA.classList.add('mm-none');
			} else {
				// Le CTA principal n'est plus visible
				if (isDesktop) {
					// Desktop: afficher seulement si l'utilisateur a déjà vu le CTA
					// et que le CTA est maintenant AU-DESSUS du viewport (scrollé vers le bas)
					const ctaRect = classicCTA.getBoundingClientRect();
					const isAboveViewport = ctaRect.bottom < 0;

					if (hasSeenMainCTA && isAboveViewport) {
						stickyCTA.classList.remove('mm-none');
					} else {
						stickyCTA.classList.add('mm-none');
					}
				} else {
					// Mobile: comportement actuel (afficher dès que non visible)
					stickyCTA.classList.remove('mm-none');
				}
			}
		});
	}, {
		root: null, // viewport par défaut
		threshold: 0 // détecter si n'importe quelle partie de l'élément est visible
	});

	// Lancer l'observation du CTA principal
	observer.observe(classicCTA);

	// Gérer le resize pour mettre à jour hasSeenMainCTA si passage mobile <-> desktop
	window.addEventListener('resize', () => {
		// Reset hasSeenMainCTA si on passe en mobile
		if (isMobile()) {
			hasSeenMainCTA = false;
		}
	});

	// Gérer les clics sur les variants du sticky CTA
	initializeStickyVariants();
}

/*********************************************************************************************
* Initialize sticky variants dropdown behavior
*/
function initializeStickyVariants() {
	const dropdown = document.querySelector('[data-sticky-variants-dropdown]');
	if (!dropdown) return;

	const trigger = dropdown.querySelector('[data-sticky-variant-trigger]');
	const options = dropdown.querySelector('[data-sticky-variant-options]');
	const variantOptions = dropdown.querySelectorAll('.mm-sticky-variant-option');

	// Calculer la largeur maximale des options et l'appliquer au dropdown
	setStickyDropdownWidth(dropdown, options);

	// Toggle dropdown
	trigger.addEventListener('click', () => {
		dropdown.classList.toggle('mm-open');
		options.classList.toggle('mm-none');
	});

	// Fermer en cliquant en dehors
	document.addEventListener('click', (e) => {
		if (!dropdown.contains(e.target)) {
			dropdown.classList.remove('mm-open');
			options.classList.add('mm-none');
		}
	});

	// Sélection d'un variant
	variantOptions.forEach(option => {
		option.addEventListener('click', () => {
			if (option.disabled) return;

			const variantId = option.dataset.variantId;

			// Fermer le dropdown
			dropdown.classList.remove('mm-open');
			options.classList.add('mm-none');

			// Mettre à jour le trigger avec le variant sélectionné
			updateStickyVariantTrigger(option);

			// Synchroniser avec le formulaire principal
			syncMainFormVariant(variantId);

			// Mettre à jour l'état actif
			variantOptions.forEach(opt => opt.classList.remove('mm-active'));
			option.classList.add('mm-active');
		});
	});
}

/*********************************************************************************************
* Set sticky dropdown width based on options max width
*/
function setStickyDropdownWidth(dropdown, options) {
	if (!dropdown || !options) return;

	// Temporairement afficher les options pour mesurer leur largeur
	options.style.visibility = 'hidden';
	options.style.display = 'block';
	options.classList.remove('mm-none');

	// Mesurer la largeur des options (inclut le padding)
	const optionsWidth = options.scrollWidth;

	// Appliquer la largeur au dropdown
	dropdown.style.minWidth = optionsWidth + 'px';

	// Remettre les options en état caché
	options.style.visibility = '';
	options.style.display = '';
	options.classList.add('mm-none');
}

/*********************************************************************************************
* Update sticky variant trigger display
*/
function updateStickyVariantTrigger(option) {
	const selectedContainer = document.querySelector('[data-sticky-variant-selected]');
	if (!selectedContainer) return;

	const title = option.dataset.variantTitle;
	const dosage = option.dataset.variantDosage;
	const price = option.dataset.variantPrice;

	let html = `<span class="mm-variant-title mm-text-16 mm-bleu-nuit">${title}</span>`;
	if (dosage) {
		html += `<span class="mm-variant-dosage mm-bleu-nuit">${dosage}</span>`;
	}
	html += `<span class="mm-variant-price mm-bleu-nuit">${price}</span>`;

	selectedContainer.innerHTML = html;
}

/*********************************************************************************************
* Sync main form with sticky variant selection
*/
function syncMainFormVariant(variantId) {
	const variantSelector = document.querySelector('variant-selector');
	if (!variantSelector) return;

	// Mettre à jour l'input hidden du formulaire
	const variantInput = document.getElementById('product_form_selected_variant_id');
	if (variantInput) {
		variantInput.value = variantId;
	}

	// Trouver et cocher le bon variant dans le formulaire principal
	const variantData = variantSelector.getVariantJSON();
	const selectedVariant = variantData.find(v => v.id == variantId);

	if (selectedVariant && selectedVariant.options) {
		// Cocher les options correspondantes dans le formulaire principal
		selectedVariant.options.forEach((optionValue) => {
			const optionInputs = variantSelector.querySelectorAll(`input[name^="options["]`);
			optionInputs.forEach(optionInput => {
				if (optionInput.value === optionValue) {
					optionInput.checked = true;
				}
			});
		});

		// Déclencher le changement sur le variant selector
		variantSelector.dispatchEvent(new Event('change'));
	}
}

/*********************************************************************************************
* Initialize the Splide carousel for the reassurance slider.
	*
*/
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}

	// Slider mobile dans le bottom sheet
	var splideElemMobile = document.querySelector("#slider-reassurance-mobile");

	if (splideElemMobile) {
		var mobile = new Splide(splideElemMobile, {
			type: "loop",
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 3000,
			perPage: 1,
			speed: 500,
		});
		mobile.mount();
	}
}

/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtns = document.querySelectorAll(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtns.forEach(btn => btn.setAttribute("disabled", "true")); // Désactiver tous les boutons "+"
		} else {
			plusBtns.forEach(btn => btn.removeAttribute("disabled")); // Réactiver tous les boutons "+"
		}

		// Mise à jour de tous les inputs de quantité avec le même data-qtty-input
		const allQttyInputs = document.querySelectorAll(`[data-qtty-input="${inputId}"]`);
		allQttyInputs.forEach(qttyInput => {
			qttyInput.value = newValue;
		});

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			price.innerHTML = ((priceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = ((comparePriceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
* Class for handling variant selection
	*
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");

		this.onVariantChange = this.onVariantChange.bind(this);
		this.connectedOnce = false;
	}

	connectedCallback() {
		if (this.connectedOnce) return;
		this.connectedOnce = true;

		this.getVariantJSON();
		this.buildOptionGroups();

		this.addEventListener("change", this.onVariantChange);

		// Init
		this.getSelectedOptions();
		this.updateUnitesVisibilityAvailability(); // << ne gère que "Unités"
		this.ensureValidUnitesSelection();         // << corrige si la valeur cochée est masquée/disabled
		this.getSelectedOptions();
		this.getSelectedVariant();
		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) this.updateImagesVariant(); else this.updateMedia();
			this.variantFetch();
		}
	}

	/* ------------------------- helpers structure ------------------------- */
	buildOptionGroups() {
		this.optionGroups = [];
		const groups = this.querySelectorAll(".mm-product-variant-picker-container");
		groups.forEach(group => {
			const firstInput = group.querySelector('input[name^="options["]');
			if (!firstInput) return;
			const m = firstInput.name.match(/^options\[(.+?)\]$/);
			if (!m) return;
			const name = m[1];
			const inputs = Array.from(group.querySelectorAll(`input[name="options[${name}]"]`));
			this.optionGroups.push({ name, groupEl: group, inputs });
		});

		// Index des groupes par nom (utile pour retrouver l’index dans variant.options)
		this.groupIndexByName = {};
		this.optionGroups.forEach((g, idx) => { this.groupIndexByName[g.name] = idx; });
	}

	getGroup(name) {
		return this.optionGroups.find(g => g.name === name);
	}

	getVariantJSON() {
		if (this.variantData) return this.variantData;
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedOptions() {
		this.options = this.optionGroups.map(g => {
			const c = g.inputs.find(i => i.checked);
			return c ? c.value : null;
		});
	}

	getSelectedVariant() {
		const opts = this.options;
		if (!opts || opts.includes(null)) { this.currentVariant = null; return; }
		// Retirer la condition v.available pour permettre la sélection de variantes en rupture (pour back in stock)
		this.currentVariant = this.getVariantJSON().find(v => {
			if (!v.options) return false;
			const match = v.options.every((val, i) => val === opts[i]);
			return match; // Permet maintenant de sélectionner des variantes non disponibles
		}) || null;
	}

	/* ------------------------- nouvelles règles ------------------------- */
	onVariantChange() {
		this.getSelectedOptions();

		// Met à jour UNIQUEMENT l'option "Unités"
		this.updateUnitesVisibilityAvailability();
		this.ensureValidUnitesSelection();

		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			if (this.dataset.imageVariant) this.updateImagesVariant(); else this.updateMedia();
			/* INP : replaceState coute ~60 ms a CPU x4 (historique intercepte par les
			   scripts tiers) ; on laisse le navigateur peindre la selection avant. */
			this.yieldToMain().then(() => {
				if (!this.currentVariant) return;
				this.updateURL(true);
				this.variantFetch();
			});
		}
	}

	yieldToMain() {
		if (window.scheduler && typeof window.scheduler.yield === 'function') return window.scheduler.yield();
		return new Promise(resolve => setTimeout(resolve, 0));
	}

	updateUnitesVisibilityAvailability() {
		const formatGroup = this.getGroup("Format");
		const unitesGroup = this.getGroup("Unités");
		if (!unitesGroup) return;

		// On ne masque/disable que "Unités" ; on laisse "Format" intact
		const selectedFormat = formatGroup ? (formatGroup.inputs.find(i => i.checked)?.value || null) : null;

		const iFormat = this.groupIndexByName["Format"];
		const iUnites = this.groupIndexByName["Unités"];

		// Pour chaque valeur "Unités", déterminer:
		// - existe-t-il au moins une variante avec (Format = selectedFormat, Unités = valeur) ? sinon => MASQUER (.mm-none)
		// - si oui, est-ce que TOUTES ces variantes sont indisponibles ? si oui => DISABLED + .mm-disabled
		unitesGroup.inputs.forEach(input => {
			const wrapper = input.closest('.mm-product-form-variant-value') || input.parentElement || input;
			// reset visuel
			wrapper.classList.remove('mm-none');
			input.classList.remove('mm-disabled');
			const label = input.closest('label');
			if (label) label.classList.remove('mm-disabled');
			// reset disabled (on ne le mettra que si OOS)
			input.disabled = false;

			let matching = this.getVariantJSON().filter(v => {
				// si aucun format sélectionné, on autorise toutes les combinaisons existantes pour cette valeur d’Unités
				const formatOK = (selectedFormat == null) ? true : (v.options[iFormat] === selectedFormat);
				return formatOK && v.options[iUnites] === input.value;
			});

			if (matching.length === 0) {
				// combinaison impossible => masquer (pas disabled)
				wrapper.classList.add('mm-none');
				if (input.checked) input.checked = false;
				return;
			}

		// combinaison existe ; si toutes OOS => classe visuelle uniquement (pas de disabled pour permettre le back in stock)
		const anyAvailable = matching.some(v => v.available);
		if (!anyAvailable) {
			// Ne pas désactiver l'input pour permettre la sélection pour Klaviyo Back in Stock
			// input.disabled = true; // COMMENTÉ pour back in stock
			input.classList.add('mm-disabled');
			if (label) label.classList.add('mm-disabled');
			// on laisse visible et sélectionnable pour le back in stock
			// if (input.checked) input.checked = false; // COMMENTÉ pour back in stock
		}
		});
	}

	ensureValidUnitesSelection() {
		const unitesGroup = this.getGroup("Unités");
		if (!unitesGroup) return;

		const checked = unitesGroup.inputs.find(i => i.checked);
		const isHidden = checked ? (checked.closest('.mm-product-form-variant-value')?.classList.contains('mm-none')) : true;
		// Ne plus vérifier isDisabled pour permettre le back in stock
		// const isDisabled = checked ? checked.disabled : true;

		// Ne forcer une nouvelle sélection QUE si l'option est cachée (.mm-none), pas si elle est juste en rupture
		if (!checked || isHidden) {
			// prendre la 1re valeur visible (même si disabled visuellement)
			const firstOK = unitesGroup.inputs.find(i => {
				const wrap = i.closest('.mm-product-form-variant-value');
				const visible = wrap ? !wrap.classList.contains('mm-none') : true;
				return visible; // on ne vérifie plus !i.disabled
			});
			if (firstOK) firstOK.checked = true;
		}
	}

	/* ------------------------- reste (inchangé) ------------------------- */
	updateURL(isVariantChange = false) {
		if (isVariantChange) {
			window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}
	}

	variantFetch() {
		const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
		if (this.cached[variantUrl]) { this.renderVariantInfo(this.cached[variantUrl]); return; }

		fetch(variantUrl)
			.then(r => r.text())
			.then(txt => {
				const html = new DOMParser().parseFromString(txt, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch(console.error);
	}

	renderVariantInfo(html) {
		this.updateMultipleElement(".mm-reload", html);
		this.updatePrixDose();
		this.updateElementOuter('.mm-product-form-component-dluo', html);
		this.updateImagesVariant();
		this.updateCTAButton(html); // Mise à jour du bouton CTA
		this.updateLivraisonInfo(html); // Mise à jour des infos de livraison
		this.updateTracabilite(); // Cartes de traçabilité (COA) liées au lot de la variante
	}

	updateTracabilite() {
		// La section traçabilité est hors de #product-form : elle expose son propre swap.
		if (!this.currentVariant || typeof window.mmTracabiliteShowVariant !== 'function') return;
		window.mmTracabiliteShowVariant(this.currentVariant.id);
	}

	updatePrixDose() {
		const prixDoseElement = this.container.querySelector('[data-prix-dose]');
		const variantMetafields = document.querySelector('[data-variant-metafields]');
		if (!prixDoseElement || !variantMetafields) return;
		try {
			const metafieldsData = JSON.parse(variantMetafields.textContent);
			const current = metafieldsData[this.currentVariant?.id];
			if (current && current.prix_par_dose) {
				prixDoseElement.textContent = current.prix_par_dose;
				prixDoseElement.style.display = 'block';
			} else {
				prixDoseElement.style.display = 'none';
			}
		} catch (e) { console.error('Erreur lors de la mise à jour du prix par dose:', e); }
	}

	updateCTAButton(html) {
		// Récupérer le conteneur du bouton CTA actuel et celui du HTML mis à jour
		const currentCTA = this.container.querySelector('[data-cta]');
		const newCTA = html.querySelector('[data-cta]');

		if (!currentCTA || !newCTA) return;

		// Remplacer le contenu du CTA par celui de la nouvelle variante
		currentCTA.innerHTML = newCTA.innerHTML;

		// Réinitialiser Klaviyo si le bouton back in stock est présent
		if (currentCTA.querySelector('.klaviyo-bis-trigger') && window.klaviyo) {
			// Attendre un court instant pour que Klaviyo détecte le nouveau bouton
			setTimeout(() => {
				if (window.klaviyo && typeof window.klaviyo.push === 'function') {
					window.klaviyo.push(['track', 'BIS Rendered']);
				}
			}, 100);
		}

		// Synchroniser le sticky CTA avec le CTA principal
		this.updateStickyCTA(html);
	}

	updateStickyCTA(html) {
		// Mettre à jour le sticky CTA desktop
		const stickyCTABtn = document.querySelector('[data-sticky-cta-btn]');
		const newStickyCTABtn = html.querySelector('[data-cta]');
		if (stickyCTABtn && newStickyCTABtn) {
			stickyCTABtn.innerHTML = newStickyCTABtn.innerHTML;
		}

		// Mettre à jour le sticky CTA mobile (bouton dans le bottom sheet)
		const stickyCTABtnMobile = document.querySelector('[data-sticky-sheet-add-to-cart]');
		if (stickyCTABtnMobile && newStickyCTABtn) {
			stickyCTABtnMobile.innerHTML = newStickyCTABtn.innerHTML;
		}

		// Mettre à jour le dropdown des variants dans le sticky
		if (this.currentVariant) {
			// Mettre à jour l'option active dans le dropdown desktop
			const variantOptions = document.querySelectorAll('.mm-sticky-variant-option');
			variantOptions.forEach(option => {
				const variantId = option.dataset.variantId;
				if (variantId == this.currentVariant.id) {
					option.classList.add('mm-active');
					// Mettre à jour le trigger
					updateStickyVariantTrigger(option);
				} else {
					option.classList.remove('mm-active');
				}
			});

			// Mettre à jour l'option active dans le bottom sheet mobile
			const sheetVariants = document.querySelectorAll('[data-sheet-variant-id]');
			sheetVariants.forEach(variant => {
				if (variant.dataset.sheetVariantId == this.currentVariant.id) {
					variant.classList.add('mm-active');
				} else {
					variant.classList.remove('mm-active');
				}
			});

			// Mettre à jour la baseline avec le titre du variant
			const stickyBaseline = document.querySelector('.mm-sticky-cta-baseline');
			if (stickyBaseline) {
				stickyBaseline.textContent = this.currentVariant.title;
			}

			// Mettre à jour le prix dans le trigger mobile
			const mobileTriggerPrice = document.querySelector('.mm-sticky-mobile-price');
			if (mobileTriggerPrice) {
				mobileTriggerPrice.textContent = this.currentVariant.price ?
					(this.currentVariant.price / 100).toFixed(2).replace('.', ',') + '€' : '';
			}
		}
	}

	updateLivraisonInfo(html) {
		// Récupérer l'élément de livraison actuel et celui du HTML mis à jour
		const currentLivraison = this.container.querySelector('.mm-product-livraison');
		const newLivraison = html.querySelector('.mm-product-livraison');

		if (!currentLivraison || !newLivraison) return;

		// Remplacer le contenu de la section livraison par celui de la nouvelle variante
		currentLivraison.innerHTML = newLivraison.innerHTML;

		// Réexécuter le script de calcul de livraison s'il existe
		const scriptElements = currentLivraison.querySelectorAll('script');
		scriptElements.forEach(oldScript => {
			const newScript = document.createElement('script');
			// Copier tous les attributs
			Array.from(oldScript.attributes).forEach(attr => {
				newScript.setAttribute(attr.name, attr.value);
			});
			// Copier le contenu du script
			newScript.textContent = oldScript.textContent;
			// Remplacer l'ancien script par le nouveau pour le réexécuter
			oldScript.parentNode.replaceChild(newScript, oldScript);
		});
	}

	updateElement(selector, html) {
		const dest = this.container.querySelector(selector);
		const src = html.querySelector(selector);
		if (src && dest) dest.innerHTML = src.innerHTML;
	}

	updateElementOuter(selector, html) {
		const dest = this.container.querySelector(selector);
		const src = html.querySelector(selector);
		if (src && dest) dest.outerHTML = src.outerHTML;
	}

	updateMultipleElement(selector, html) {
		const dest = this.container.querySelectorAll(selector);
		const src = html.querySelectorAll(selector);
		if (src && dest) {
			for (let i = 0; i < src.length; i++) {
				if (dest[i] && src[i]) dest[i].outerHTML = src[i].outerHTML;
			}
		}
	}

	updateMedia() {
		if (this.currentVariant && this.currentVariant.featured_media) {
			const variant_media_id = this.currentVariant.featured_media.id;
			const allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

			// Récupérer l'instance Splide principale (définie dans mm-product-medias.liquid)
			const mainSlider = document.querySelector('#main-slider');
			if (!mainSlider || !mainSlider.splide) return;

			allMainMedia.forEach((media, index) => {
				if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
					mainSlider.splide.go(index);
				}
			});
		}
	}

	updateImagesVariant() {
		const allMain = document.querySelectorAll(".main-slider-variant");
		allMain.forEach(media => {
			if (this.currentVariant && media.dataset.variantid == this.currentVariant.id) media.style.display = "flex";
			else media.style.display = "none";
		});
		const allThumb = document.querySelectorAll(".thumbnail-slider-variant");
		allThumb.forEach(media => {
			if (this.currentVariant && media.dataset.variantid == this.currentVariant.id) media.style.display = "flex";
			else media.style.display = "none";
		});
	}
}

customElements.define("variant-selector", VariantSelector);



/*********************************************************************************************
* Copy promo code to clipboard
	*
	* @param {string} code - The promo code to copy.
	* @param {string} blockId - The block ID for showing confirmation message.
*/
function mmCopyPromoCode(code, blockId) {
	// Copier dans le presse-papiers
	navigator.clipboard.writeText(code).then(() => {
		// Afficher le message "Copié !"
		const copiedMessage = document.getElementById(`promo-copied-${blockId}`);
		if (copiedMessage) {
			copiedMessage.classList.remove('mm-none');

			// Masquer le message après 2 secondes
			setTimeout(() => {
				copiedMessage.classList.add('mm-none');
			}, 2000);
		}
	}).catch(err => {
		console.error('Erreur lors de la copie du code promo:', err);
	});
}

// Fonction pour copier le code promo
function mmCopyPromoCode(code, blockId) {
     navigator.clipboard.writeText(code).then(function() {
         const copiedElement = document.getElementById('promo-copied-' + blockId);
         if (copiedElement) {
             copiedElement.classList.remove('mm-none');
             setTimeout(function() {
                 copiedElement.classList.add('mm-none');
             }, 2000);
         }
     }).catch(function(err) {
         console.error('Erreur lors de la copie: ', err);
     });
 }

 // Fonction pour ouvrir la popup Clean Label
 function mmOpenCleanLabelPopup() {
     const popupContainer = document.getElementById('clean-label-popup');
     if (!popupContainer) return;

     // Créer l'overlay s'il n'existe pas
     let overlay = document.querySelector('.mm-popup-overlay-clean-label');
     if (!overlay) {
         overlay = document.createElement('div');
         overlay.className = 'mm-popup-overlay mm-popup-overlay-clean-label';
         document.body.appendChild(overlay);
     }

     // Ouvrir la popup
     popupContainer.classList.remove('mm-none');
     popupContainer.classList.add('mm-open');
     overlay.classList.add('mm-open');
     document.body.style.overflow = 'hidden';

     // Focus sur le bouton de fermeture
     setTimeout(() => {
         const closeButton = popupContainer.querySelector('.mm-icon-close-popup');
         if (closeButton) closeButton.focus();
     }, 100);

     // Gestionnaire de fermeture
     const closeButton = popupContainer.querySelector('.mm-icon-close-popup');
     if (closeButton) {
         closeButton.onclick = function(e) {
             e.preventDefault();
             e.stopPropagation();
             closeCleanLabelPopup();
         };
     }

     // Fermer au clic sur l'overlay
     overlay.onclick = closeCleanLabelPopup;

     // Fermer avec Échap
     document.addEventListener('keydown', function escapeHandler(e) {
         if (e.key === 'Escape' && popupContainer.classList.contains('mm-open')) {
             closeCleanLabelPopup();
             document.removeEventListener('keydown', escapeHandler);
         }
     });
 }

 // Fonction pour fermer la popup Clean Label
 function closeCleanLabelPopup() {
     const popupContainer = document.getElementById('clean-label-popup');
     const overlay = document.querySelector('.mm-popup-overlay-clean-label');

     if (popupContainer) {
         popupContainer.classList.remove('mm-open');
         document.body.style.overflow = '';

         setTimeout(() => {
             popupContainer.classList.add('mm-none');
         }, 300);
     }

     if (overlay) {
         overlay.classList.remove('mm-open');
     }
 }

/*********************************************************************************************
* Initialize Mobile Sticky Bottom Sheet
*/
function initializeMobileStickySheet() {
	const trigger = document.querySelector('[data-sticky-mobile-trigger]');
	const sheet = document.querySelector('[data-sticky-mobile-sheet]');
	const overlay = document.querySelector('[data-sticky-mobile-overlay]');
	const closeBtn = document.querySelector('[data-sticky-mobile-close]');

	if (!trigger || !sheet || !overlay) return;

	// Store reference to trigger for focus restoration
	let lastFocusedElement = null;

	// Open sheet on trigger click
	trigger.addEventListener('click', () => {
		lastFocusedElement = document.activeElement;
		openMobileSheet(sheet, overlay, closeBtn);
	});

	// Close sheet on close button click
	if (closeBtn) {
		closeBtn.addEventListener('click', () => {
			closeMobileSheet(sheet, overlay, lastFocusedElement);
		});
	}

	// Close sheet on overlay click
	overlay.addEventListener('click', () => {
		closeMobileSheet(sheet, overlay, lastFocusedElement);
	});

	// Handle keyboard events
	sheet.addEventListener('keydown', (e) => {
		// Close on Escape
		if (e.key === 'Escape') {
			e.preventDefault();
			closeMobileSheet(sheet, overlay, lastFocusedElement);
			return;
		}

		// Focus trap - Tab navigation
		if (e.key === 'Tab') {
			trapFocusInSheet(e, sheet);
		}
	});

	// Initialize variant selection in sheet
	initializeSheetVariants();
}

/*********************************************************************************************
* Open Mobile Sheet with accessibility
*/
function openMobileSheet(sheet, overlay, closeBtn) {
	sheet.hidden = false;
	sheet.classList.remove('mm-none');
	overlay.classList.remove('mm-none');

	// Set ARIA attributes
	sheet.setAttribute('role', 'dialog');
	sheet.setAttribute('aria-modal', 'true');

	// Trigger reflow for animation
	sheet.offsetHeight;
	overlay.offsetHeight;

	sheet.classList.add('mm-open');
	overlay.classList.add('mm-open');

	// Prevent body scroll
	document.body.style.overflow = 'hidden';

	// Focus on close button for accessibility
	if (closeBtn) {
		setTimeout(() => closeBtn.focus(), 100);
	}
}

/*********************************************************************************************
* Close Mobile Sheet with accessibility
*/
function closeMobileSheet(sheet, overlay, lastFocusedElement) {
	sheet.classList.remove('mm-open');
	overlay.classList.remove('mm-open');

	// Re-enable body scroll
	document.body.style.overflow = '';

	// Hide after animation
	setTimeout(() => {
		sheet.classList.add('mm-none');
		overlay.classList.add('mm-none');
		sheet.hidden = true;
	}, 300);

	// Restore focus to trigger element
	if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
		lastFocusedElement.focus();
	}
}

/*********************************************************************************************
* Trap focus within the sheet for accessibility
*/
function trapFocusInSheet(e, sheet) {
	const focusableElements = sheet.querySelectorAll(
		'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
	);

	if (focusableElements.length === 0) return;

	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];

	if (e.shiftKey) {
		// Shift + Tab: go to last element if on first
		if (document.activeElement === firstElement) {
			e.preventDefault();
			lastElement.focus();
		}
	} else {
		// Tab: go to first element if on last
		if (document.activeElement === lastElement) {
			e.preventDefault();
			firstElement.focus();
		}
	}
}

/*********************************************************************************************
* Initialize Sheet Variants Selection
*/
function initializeSheetVariants() {
	const sheetVariants = document.querySelectorAll('[data-sheet-variant-id]');
	if (!sheetVariants.length) return;

	sheetVariants.forEach(variant => {
		// Variante épuisée sélectionnable : le CTA bascule sur « Être informé » (Klaviyo)
		variant.addEventListener('click', () => {
			const variantId = variant.dataset.sheetVariantId;

			// Update active state and ARIA
			sheetVariants.forEach(v => {
				v.classList.remove('mm-active');
				v.setAttribute('aria-pressed', 'false');
			});
			variant.classList.add('mm-active');
			variant.setAttribute('aria-pressed', 'true');

			// Sync with main form
			syncMainFormVariant(variantId);

			// Update mobile trigger price
			updateMobileTriggerPrice(variant.dataset.variantPrice);
		});

		// Keyboard support for variant selection
		variant.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				variant.click();
			}
		});
	});
}

/*********************************************************************************************
* Update Mobile Trigger Price
*/
function updateMobileTriggerPrice(price) {
	const priceElement = document.querySelector('.mm-sticky-mobile-price');
	if (priceElement && price) {
		priceElement.textContent = price;
	}
}

/*********************************************************************************************
* Initialize Booking Buttons (Easy Appointment Booking)
*
* L'app rend son propre bouton, qui porte le listener React ouvrant le calendrier.
* Ce bouton ne peut etre ni deplace ni duplique : on rend des CTA Dynveo natifs
* (mm-btn-booking) et on delegue leur clic au bouton de l'app.
*
* Les CTA natifs restent masques tant que le bouton de l'app n'est pas present,
* pour ne jamais afficher un bouton sans effet si l'app ne charge pas.
*/
function initializeBookingButtons() {
	const triggers = document.querySelectorAll('[data-mm-booking-trigger]');
	if (!triggers.length) return;

	// Le bouton de l'app vit dans le bloc produit. On l'exclut du header, dont le
	// mega-menu rend des product cards portant les memes classes servicify.
	const getAppButton = () => {
		const candidates = document.querySelectorAll('.servicify-popup-calendar-button');
		for (const candidate of candidates) {
			if (candidate.closest('header')) continue;
			return candidate;
		}
		return null;
	};

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			const appButton = getAppButton();

			if (appButton) {
				appButton.click();
				return;
			}

			// Bloc app absent du template : on renvoie vers le calendrier inline
			// s'il est present, sinon on ne fait rien de destructeur.
			const inlineCalendar = document.querySelector('.servicify-inline-calendar');
			if (inlineCalendar) {
				inlineCalendar.scrollIntoView({ behavior: 'smooth', block: 'center' });
				return;
			}

			if (window.log) window.log('warn', '📅 [BOOKING]', 'Aucun bouton Easy Appointment Booking dans la page');
		});
	});
}

/*********************************************************************************************
* Lire plus / Lire moins de la description produit (repli après la 7e puce).
* Le contenu replié est déjà dans le HTML : on ne bascule que la classe et aria-expanded.
*/
function initializeDescriptionToggle() {
	document.querySelectorAll('[data-description-toggle]').forEach((button) => {
		const content = document.getElementById(button.getAttribute('aria-controls'));
		if (!content) return;

		button.addEventListener('click', () => {
			const isOpen = button.getAttribute('aria-expanded') === 'true';
			button.setAttribute('aria-expanded', String(!isOpen));
			content.classList.toggle('is-open', !isOpen);
			button.textContent = isOpen ? button.dataset.labelMore : button.dataset.labelLess;
		});
	});
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	initializeDescriptionToggle();
	mmSlideProductReassurance();
	initializeStickyCTA();
	initializeMobileStickySheet();
	initializeBookingButtons();
});
